// extracted by mini-css-extract-plugin
module.exports = {"greenEllipse":"style-module__greenEllipse___x8lZE","navbarContainer":"style-module__navbarContainer___3xgfs","registeredMark":"style-module__registeredMark___S-Jd3"};